import React, { ComponentProps, forwardRef } from 'react';
import { FilledInput as FilledInputMUI } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

import { ShapeProp } from '@/mui/types';

type Props = ComponentProps<typeof FilledInputMUI> & {
  shape?: ShapeProp;
};

const FilledInput = forwardRef<HTMLInputElement, Props>(({ shape, sx, ...rest }, ref) => {
  const theme = useTheme();

  const shapeStyles =
    // eslint-disable-next-line no-nested-ternary
    shape === SHAPE_SQUARE
      ? {
          borderRadius: 0,
          '&:before': {
            left: 0,
            right: 0,
          },
          '&:after': {
            left: 0,
            right: 0,
          },
        }
      : shape === SHAPE_CIRCULAR
        ? {
            borderRadius: theme.shape.borderRadiusCircular,
            '&:before': {
              left: 16,
              right: 16,
            },
            '&:after': {
              left: 16,
              right: 16,
            },
          }
        : {};

  return <FilledInputMUI ref={ref} {...rest} sx={{ ...shapeStyles, ...sx }} />;
});

FilledInput.displayName = 'FilledInput';

export default FilledInput;
